<template>
  <div class="topmenu">
    <div
      v-for="(item, index) in menuList"
      :key="index"
      class="topmenu-item"
      @click="jump(item)"
    >
      {{ item.title }}
      <div v-if="index !== menuList.length - 1" class="topmenu-split"></div>
    </div>
    <div class="topmenu-cancel" @click="$eb.$emit('showTopMenu', false)">
      取消
    </div>
  </div>
</template>
<script>
export default {
  name: 'TopMenu',
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
    brightness: {
      type: Number,
      default: 0.8,
    },
  },
  methods: {
    jump(item) {
      this.$eb.$emit('showTopMenu', false, item)
      this.$bridge.openPage(item.jumpUrl)
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.topmenu {
  .flex-column-center();
  .font-area(14px);
  z-index: 13;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #f5f5f5;
  width: 100%;
  font-family: PingFangSC-Medium;
  color: rgba(0, 0, 0, 0.9);
  text-align: center;
  &-item {
    width: 100%;
    background: #ffffff;
    height: 55px;
    text-align: center;
    line-height: 55px;
  }
  &-split {
    width: 100%;
    height: 1px;
    background: #e5e5e5;
    transform: scaleY(0.5);
  }
  &-cancel {
    width: 100%;
    margin-top: 10px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    background: #ffffff;
  }
}
</style>
